<script setup lang="ts">
import cliLogo from '~/assets/img/cli-logo.svg'
</script>

<template>
  <NavBar />
  <img width="343.45px" height="96px" class="mt-5" :src="cliLogo" alt="CLI Logo" />
  <main class="container-md g-2" style="min-height: calc(100vh - 50px)">
    <div class="row g-2 justify-content-center my-5 p-2">
      <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11">
        <slot />
      </div>
    </div>
  </main>
  <PageFooter />
</template>
